import {useCallback, useState} from 'react';

import NiceModal, {useModal} from '@ebay/nice-modal-react';
import {Observer} from 'mobx-react';

import {useI18n} from '@yourcoach/i18n';

import {alert} from '../../../../../../../../components/alert';
import {Modal} from '../../../../../../../../components/Modal';
import * as S from './styles';

type Props = {
  onSubmitComment: (text: string) => Promise<void>;
};

export const MotivationalCommentModal = NiceModal.create<Props>(
  ({onSubmitComment}) => {
    const [commentText, setCommentText] = useState('');
    const [loading, setLoading] = useState(false);
    const modal = useModal();
    const {t} = useI18n();

    const handleDone = useCallback(async () => {
      const text = commentText.trim();

      if (!text || !onSubmitComment) return;

      setLoading(true);

      try {
        await onSubmitComment(text);
        modal.hide();
      } catch (e) {
        alert.error(e);
      } finally {
        setLoading(false);
      }
    }, [commentText, onSubmitComment, modal]);

    return (
      <Modal
        isOpen={modal.visible}
        maxWidth="420px"
        onAfterClose={modal.remove}
        onRequestClose={modal.hide}
        title={t('shared:do_you_have_any_non_scale_victories_to_share')}
      >
        <Observer>
          {() => (
            <S.Container>
              <S.Input
                onChange={e => setCommentText(e.payload?.text ?? '')}
                placeholder={t('shared:add_comment')}
                value={commentText}
              />
              <S.SubmitButton
                disabled={!commentText.trim()}
                isLoading={loading}
                onClick={handleDone}
              >
                {t('shared:done')}
              </S.SubmitButton>
            </S.Container>
          )}
        </Observer>
      </Modal>
    );
  },
);
